"use client";

import Link from "next/link";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";
import { PriceLink } from "./price-link";
import { RechargeLink } from "./recharge-link";
import { Separator } from "@/components/ui/separator";

export function SiteFooter() {
  const t = useTranslations("footer");
  const params = useParams();
  const lang = params.lang as string || "zh";

  return (
    <footer className="w-full bg-[#1C1F24] text-gray-300 pt-6 pb-5 px-6 md:px-20">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center overflow-hidden">
              <Image
                src="/img/favicon.png"
                alt={t("companySection.companyName")}
                width={40}
                height={40}
                className="rounded-lg"
              />
            </div>
            <span className="text-lg font-semibold text-white">{t("companySection.companyName")}</span>
          </div>

          <p className="text-sm leading-relaxed text-gray-400 whitespace-pre-line">
            {t("companySection.companyDesc")}
          </p>
        </div>

        <div>
          <h3 className="text-white font-medium mb-4">{t("quickLinks.title")}</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link href={`/${lang}`} className="hover:text-white transition">
                {t("quickLinks.home")}
              </Link>
            </li>
            <li>
              <Link
                href="https://diceui.com/docs/components/data-grid"
                className="hover:text-white transition"
              >
                {t("quickLinks.docs")}
              </Link>
            </li>
            <li className="text-gray-400 [&_a]:text-gray-300! [&_a]:hover:text-white!">
              <PriceLink />
            </li>
            <li>
              <Link
                href={process.env.NEXT_PUBLIC_DOC_URL || "https://doc.ai.soraliststudio.com"}
                className="hover:text-white transition"
              >
                {t("quickLinks.faq")}
              </Link>
            </li>
            <li className="text-gray-400 [&_a]:text-gray-300! [&_a]:hover:text-white!">
              <RechargeLink />
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-medium mb-4">{t("supportHelp.title")}</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                href={process.env.NEXT_PUBLIC_DOC_URL || "https://doc.ai.soraliststudio.com"}
                className="hover:text-white transition"
              >
                {t("supportHelp.tutorial")}
              </Link>
            </li>
            <li>
              <Link
                href={process.env.NEXT_PUBLIC_DOC_URL || "https://doc.ai.soraliststudio.com"}
                className="hover:text-white transition"
              >
                {t("supportHelp.apiDocs")}
              </Link>
            </li>
            <li></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-medium mb-4">{t("friendlyLinks.title")}</h3>
          <ul className="space-y-2 text-sm">
            <Link href="https://seektool.ai" className="hover:text-white transition">
              SeekTool.AI
            </Link>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-medium mb-4">{t("contactUs.title")}</h3>
          <div className="text-sm space-y-3 text-gray-400">
            <p>
              {t("contactUs.wechat")}
              <br />
              Ki_Arser
            </p>
            <p>
              {t("contactUs.email")}
              <br />
              yyzn@soraliststudio.com
            </p>

            <p>
              {t("contactUs.workingHours")}
              <br />
              {t("contactUs.workingTime")}
            </p>
          </div>
        </div>
      </div>

      <Separator className="my-5 bg-gray-700" />

      <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
        <p className="mb-4 md:mb-0">{t("bottomSection.copyright")} {t("bottomSection.rightsReserved")}</p>

        <div className="flex flex-wrap gap-6 text-sm">
          <Link href={`/${lang}/terms`} className="hover:text-white transition">
            {t("bottomSection.terms")}
          </Link>
          <Link href={`/${lang}/privacy`} className="hover:text-white transition">
            {t("bottomSection.privacy")}
          </Link>
          <Link href={`/${lang}/policy`} className="hover:text-white transition">
            {t("bottomSection.usage")}
          </Link>
          <Link href={`/${lang}/datasecurity`} className="hover:text-white transition">
            {t("bottomSection.security")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
